import round from 'helpers/mathRound';
import { getAlleDiscount } from 'pages/quotes/helpers';
import { getDiscount } from './getDiscount';


export const calculateTotals = (selectedItems = [], products) => {
  const totals = selectedItems.reduce((acc, item) => {
    const {
      sku,
      qty,
      subscription_id,
      discountType,
      discount,
      fixedPrice
    } = item;

    const {
      savings = 0,
      price = 0,
      subscription_active,
      subscription_options,
      additional_subscription_price = 0,
      quotepro_discounts,
      name = 0
    } = products[sku]?.product || [];

    const productAlleData = {
      sku,
      name
    };

    const itemPrice = fixedPrice ? fixedPrice : price;

    const customQuoteproDiscounts = {
      price_type: discountType,
      price: discount
    };

    const dataForDiscount = {
      savings: Number(savings),
      discount_options: quotepro_discounts && quotepro_discounts !== '[]' ? JSON.parse(quotepro_discounts) : [customQuoteproDiscounts],
      price: itemPrice
    };

    const isAlleSKU = sku.includes('bdsku');
    const itemDiscount = isAlleSKU
      ? round(getAlleDiscount(productAlleData)) || 0
      : round(getDiscount(item, dataForDiscount)) || 0;

    let itemRegularPrice = itemPrice ? itemPrice * qty : (itemPrice - Number(savings)) * qty;

    if (subscription_id) {
      const subscriptionData = subscription_options?.find((s) => Number(s.id) === Number(subscription_id));

      const isSubscriptionActive = subscription_active === '1';
      const isNullPrice = subscriptionData?.installment_price === null && subscriptionData?.adjustment_price === null;

      if (isSubscriptionActive && !isNullPrice && subscriptionData && itemPrice == 0) {
        itemRegularPrice = qty * round(subscriptionData?.installment_price + subscriptionData?.adjustment_price + savings);
      }
    }

    const itemGrandTotal = itemRegularPrice - itemDiscount;
    const totalAdditionalSubscriptionPrice = round(additional_subscription_price || 0);

    return {
      ...acc,
      totalAdditionalSubscriptionPrice: acc.totalAdditionalSubscriptionPrice += Number(totalAdditionalSubscriptionPrice),
      grandTotal: acc.grandTotal += Number(itemGrandTotal),
      discountTotal: acc.discountTotal += Number(itemDiscount)
    };
  }, {grandTotal: 0, discountTotal: 0, totalAdditionalSubscriptionPrice: 0});
  return totals;
};
